import styled from 'styled-components';
import {
	H1, RspImageBg
} from '../base';
import media from '../base/media';

export const Wrapper = styled.div`
	padding: 5rem 0;
	padding-top: calc(${props => props.theme.header.headerHeightMobile} + 5rem);

	${media.tablet`
		padding: 10rem 0;
	`}

	${media.desktopSmall`
		padding: 24rem 0 12rem 0;
	`}
`;

export const Content = styled.div`
	${media.tablet`
		display: flex;
		flex-direction: column;
		justify-content: center;
		max-width: 80%;
		height: 100%;
	`}

	${media.desktopLarge`
		max-width: 54rem;
	`}
`;

export const Title = styled(H1)`
	${media.desktopSmall`
		font-size: 5rem;
		line-height: 7.2rem;
	`}
`;

export const Text = styled.div`
	margin: 2rem 0;

	${media.desktopSmall`
		margin-bottom: 5rem;
	`}
`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	> a {
		margin: 1rem 0;
	}

	${media.tablet`
		flex-direction: row;
		justify-content: space-between;
	`}
`;

export const Image = styled(RspImageBg)`
	${media.tablet`
		padding-top: 200%;
		background-size: cover;
		background-position: 50% 50%;
	`};

	${media.desktopSmall`
		padding-top: 140%;
	`}
`;
